module.exports = __webpack_public_path__ + "static/Template_colorbase_1-b56a7469aa776aea3729717b18991159.png";